export const REQUEST_MODELS = 'dt/models/REQUEST_MODELS';
export const RECEIVED_MODELS = 'dt/models/RECEIVED_MODELS';
export const CREATE_MODEL_AND_INITIAL_VERSION = 'dt/models/CREATE_MODEL_AND_INITIAL_VERSION';
export const ADD_MODEL_VERSION = 'dt/models/ADD_MODEL_VERSION';
export const UPDATE_MODEL = 'dt/models/UPDATE_MODEL';
export const DELETE_MODEL = 'dt/models/DELETE_MODEL';
export const UPDATE_SCENE_CONFIG = 'dt/models/UPDATE_SCENE_CONFIG';
export const RESET_MODELS = 'dt/models/RESET_MODELS';
export const ADD_UPLOADING_ID = 'dt/models/ADD_UPLOADING_ID';
export const REMOVE_UPLOADING_ID = 'dt/models/REMOVE_UPLOADING_ID';

export const PENDING = 'PENDING';
export const PROCESSING = 'PROCESSING';
export const COMPLETED = 'COMPLETED';
export const FAILED = 'FAILED';
export const REMOVED = 'REMOVED';

export const requestModels = (siteId) => ({
  type: REQUEST_MODELS,
  siteId,
});

export const resetModels = () => ({
  type: RESET_MODELS,
});

export const receiveModels = (models, siteId) => ({
  type: RECEIVED_MODELS,
  models,
  siteId,
});

export const createModelAndInitialVersion = (data, componentId) => ({
  type: CREATE_MODEL_AND_INITIAL_VERSION,
  data,
  componentId,
});

export const addModelVersion = (data, modelId) => ({
  type: ADD_MODEL_VERSION,
  data,
  modelId,
});

export const updateModel = (modelId, data) => ({
  type: UPDATE_MODEL,
  modelId,
  data,
});

export const deleteModel = (siteId, modelId) => ({
  type: DELETE_MODEL,
  siteId,
  modelId,
});

export const updateSceneConfig = (siteId, modelId, versionId, data) => ({
  type: UPDATE_SCENE_CONFIG,
  siteId,
  modelId,
  versionId,
  data,
});

export const addUploadingId = (modelId) => ({
  type: ADD_UPLOADING_ID,
  modelId,
});

export const removeUploadingId = (modelId) => ({
  type: REMOVE_UPLOADING_ID,
  modelId,
});
